import type { FabProps } from "@mui/material";
import type React from "react";
import { IconFab } from "./styles";

interface IIconElevatedProps extends FabProps {
  icon: React.ReactNode;
}

export const IconElevated = ({ icon, ...rest }: IIconElevatedProps) => {
  return <IconFab {...rest}>{icon}</IconFab>;
};
